import { ReactNode } from 'react';
import { OrderDetailsCardRow } from './DeliveryDetails';

const hasRowValue = (value: ReactNode): boolean => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') return value.trim() !== '';
  return true;
};

export const filterRows = (rows: OrderDetailsCardRow[]): OrderDetailsCardRow[] =>
  rows.filter((row) => hasRowValue(row.label) && hasRowValue(row.value));
